import React from "react";
import { Loader2, RefreshCw } from "lucide-react";

export default function FeedRefreshBanner({ isUpdating, refreshFailed, onRetry }) {
  if (isUpdating) {
    return (
      <div className="feed-refresh-spinner" aria-live="polite" aria-label="Updating feed">
        <Loader2 size={14} className="animate-spin" aria-hidden />
      </div>
    );
  }

  if (refreshFailed) {
    return (
      <button
        type="button"
        className="feed-refresh-retry"
        onClick={onRetry}
        aria-label="Refresh failed. Tap to retry."
      >
        <RefreshCw size={14} aria-hidden />
      </button>
    );
  }

  return null;
}
